import Vue from 'vue'
import Vuex from 'vuex'


// Modules
import app from './app';
import appConfig from './app-config';
import verticalMenu from './vertical-menu';
import calendar from './modules/calendar';
import articleCategories from './modules/article-categories';
import articles from './modules/articles';
import editArticle from './modules/edit-article';
import editContact from './modules/edit-contact';
import contacts from './modules/contacts';
import accessGroups from './modules/access-groups';
import auth from './modules/auth';
import files from './modules/files';
import portfolios from './modules/portfolios';
import videos from './modules/videos';
import userPermissionsToPortfolio from './modules/userPermissionsToPortfolio';
import userPermissions from './modules/userPermissions';
import editUserPermissions from './modules/edit-userPermissions';
import userAccount from './modules/user-account';
import hideCategories from './modules/hide-categories';
import currentHomepgage from './modules/current-homepgage';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    calendar,
    articleCategories,
    articles,
    editArticle,
    editContact,
    contacts,
    accessGroups,
    auth,
    files,
    portfolios,
    videos,
    userPermissionsToPortfolio,
    userPermissions,
    editUserPermissions,
    userAccount,
    hideCategories,
    currentHomepgage
  },
  strict: process.env.DEV
})
